import { render, staticRenderFns } from "./FilterInfoBar.vue?vue&type=template&id=636dfa4a&scoped=true&"
import script from "./FilterInfoBar.vue?vue&type=script&lang=ts&"
export * from "./FilterInfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./FilterInfoBar.vue?vue&type=style&index=0&id=636dfa4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636dfa4a",
  null
  
)

export default component.exports